import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance, watch } from 'vue'
import { checkPerformDashFml, getSurveyColor, getSurveyDescription } from '@/modules/messages/utils/PerformDashFML'
import FormWithStepsRenderer from '@/modules/FML/components/FormWithStepsRenderer.vue'
import PerformDashIcon from '@/views/PerformDash/Icons/PerformDashIcon.vue'
import QButton from '@/modules/shared/components/QButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformDashSurveyPage',
  setup(__props) {

const instance = getCurrentInstance()
const slug = computed(() => (instance?.proxy.$route.params as any).form_slug as string)
const isPerformDash = computed(() => checkPerformDashFml(slug.value))
const color = computed(() => getSurveyColor(slug.value) ?? 'q_green_1')
const description = computed(() => getSurveyDescription(slug.value))

const submitted = ref(false)

watch(slug, () => {
    submitted.value = false
})

return { __sfc: true,instance, slug, isPerformDash, color, description, submitted, FormWithStepsRenderer, PerformDashIcon, QButton }
}

})